module.exports = __webpack_public_path__ + "img/album05_16.ecb4e524.jpg";